export const dynamicRoutes = {
  widenPresence: 'widen-presence',
  mitigateRisk: 'mitigate-risk',
  simplifiedExperience: 'simplified-experience',
  increaseConversion: 'increase-conversion',
  jiopay: 'jiopay',
  direct: 'direct',
  vault: 'vault',
  repeat: 'repeat',
  collect: 'collect',
  campaign: 'campaign',
  products: 'products',
  mobileCheckout: 'mobile-checkout',
  checkout: 'checkout',
  console: 'console',
  oneqr: '1qr',
  contact: 'contact',
  aboutUs: 'about-us',
  helpCenter: 'help-center',
  privacyPolicy: 'privacy-policy',
  termsNcondition: 'terms-conditions',
  jioPayBusiness: 'jio-pay-business',
  onBoardingAndKyc: 'on-boarding-and-kyc-policy',
  grievance: 'grievance-redressal-policy',
  billpayTermsAndCond: 'billpay-terms-conditions',
  QRFAQ: '1qrfaqs',
  investorRelation: 'investor-relation',
  compliantResolutionNescalationMatrix: 'complaint-resolution-escalation-matrix',
  rsil: 'rsil',
  voicebox: 'voicebox',
  voiceboxQr: 'voicebox-qr',
  packagingBoxQr: 'packagingbox-qr',
  partnerProgram: 'partner-program'
}

export const documentTitle = {
  landingScreen: 'JioPay - Business',
  rsil: 'Reliance Stratergic Investments Limited',
  contactUs: 'JioPay | Contact Us',
  aboutUs: 'JioPay | About Us',
  privacyPolicy: 'JioPay | Privacy Policy',
  termsAndConditions: 'JioPay | Terms And Condition',
  billpayTermsAndConditions: 'Billpay | Terms And Condition',
  jiopayBusiness: 'JioPay | Jio Bizz App',
  paydirect: 'JioPay | Direct',
  payrepeat: 'JioPay | Repeat',
  vault: 'JioPay | Vault',
  paycollect: 'JioPay | Collect',
  paycampaign: 'JioPay | Campaign',
  oneqr: 'JioPay | 1 QR',
  voicebox: 'JioPay | VoiceBox',
  mobileCheckout: 'JioPay | Mobile Checkout',
  console: 'JioPay | Console',
  products: 'JioPay | Products',
  investorRelation: 'JioPay | Investor Relations',
  onboardingAndKyc: 'JioPay | On Boarding and KYC Policy',
  grievancePolicy: 'JioPay | Grievance Redressal Policy',
  faqHeader: 'JioPay | FAQs',
  helpcenter: 'JioPay | Help center',
  compliantsEscalations: 'JioPay | Complaint Resolution and Escalation Matrix',
  jiopayconsumers: 'JioPay for Consumers',
  partnerProgram: 'JioPay | Partner Program'
}
